import { getQueryStringFromObject as e } from "@partoohub/utils";
import { ApiResourceBaseClass as n } from "./baseApiCalls.js";
const o = "bulk";
class c extends n {
  /**
   * Exports businesses with optional filters.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/bulk/business/exporter`
   *
   * @param {BulkExportBusinessClientFilter} queryParams - Optional query filters.
   * @returns {Promise<SuccessResponse>} A promise resolving with success response.
   */
  bulkBusinessExport = async (t) => {
    const r = e(t), { data: s } = await this.get(
      `${o}/business/exporter?${r}`
    );
    return s;
  };
  /**
   * Exports users with optional filters.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/bulk/user/exporter`
   *
   * @param {BulkUserExportFilter} queryParams - Optional query filters.
   * @returns {Promise<SuccessResponse>} A promise resolving with success response.
   */
  bulkUserExport = async (t) => {
    const r = e(t), { data: s } = await this.get(
      `${o}/user/exporter?${r}`
    );
    return s;
  };
}
export {
  c as BulkExport,
  o as RESOURCE_URI
};
